import { TeamAvatar } from '@statsbomb/kitbag-global-football';
import { NextGame } from '@statsbomb/parachute-types';
import { useAtomValue } from 'jotai';
import { Trans, useTranslation } from 'react-i18next';
import { secureBucketCookieRequestedAtom } from '@/atoms/cookies';
import { useUrlLocale } from '@/hooks/useUrlLocale';
import { QuickStartCard } from './QuickStartCard';

// The API's date has no time zone, so it is formatted in UTC to keep the scheduled day wherever the viewer is.
const formatFixtureDate = (date: string, locale: string) =>
  new Intl.DateTimeFormat(locale, { dateStyle: 'long', timeZone: 'UTC' }).format(new Date(date));

export const NextOpponentCard = ({ nextGame }: { nextGame: NextGame }) => {
  const { t } = useTranslation('home');
  const locale = useUrlLocale();
  const secureBucketCookieRequested = useAtomValue(secureBucketCookieRequestedAtom);
  const { opponent, date } = nextGame;

  return (
    <QuickStartCard
      avatar={<TeamAvatar teamId={secureBucketCookieRequested ? opponent.team_id : undefined} size="small" />}
      title={opponent.name}
      description={
        <Trans
          t={t}
          i18nKey="quickStart.nextOpponent"
          values={{ date: formatFixtureDate(date, locale) }}
          components={{ bold: <strong /> }}
        />
      }
      to={`/${locale}/team/${opponent.team_id}/dashboard`}
    />
  );
};
